'use strict';

// only exists so we can stub load-script for testing
var _load = require('load-script');
module.exports = { _load: _load };